import { render } from "./GuiSubscriptionTypeSelect.vue?vue&type=template&id=52c1f2e6"
import script from "./GuiSubscriptionTypeSelect.vue?vue&type=script&lang=js"
export * from "./GuiSubscriptionTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__